export default "__VITE_ASSET__S5OfBB7J__"